<app-loader [isLoading]="isLoading"></app-loader>
<div class="wishlist-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="wishlist-text">Add to wishlist</span>
    <div class="img-container" mat-dialog-close>
      <img src="../../../assets/images/crossIconDarkTheme.svg" class="cross-icon" />
    </div>
  </div>
  <form (ngSubmit)="addWishlist()">
    <div class="filter">
      <div class="d-flex flex-column mt-5">
        <label class="select-wishlist mb-1">Wishlist name</label>
        <input type="text" class="search-input dp-input-control" (keydown)="restrictWishlistNameInput($event)"
          placeholder="Enter a name for the wishlist" [formControl]="wishlistName" />
      </div>
      @if(data.type === 'centralizedPm' || data.type === 'pm'){
      <div class="d-flex flex-column input-div">
        <!-- <span class="input-text">Pincode</span> -->
        <label class="select-wishlist mb-1">Pincode</label>
        <input class="input dp-input-control" type="tel" placeholder="Enter Pincode*" aria-label="Search"
          [formControl]="pin" [matAutocomplete]="autopin" maxlength="6" />
        @if(pin.value?.length==0){
        <span class="error-text">Select pincode from Dropdown to create new wishlist</span>
        }
        <mat-autocomplete autoActiveFirstOption #autopin="matAutocomplete">
          @for (item of pincodeList ; track item) {
          <mat-option [value]="item">{{ item }}</mat-option>
          }
        </mat-autocomplete>
      </div>
      }
    </div>

    <div class="d-flex justify-content-center mt-5">
      <button class="dp-secondary-btn wishlist-btn" type="button" mat-dialog-close>
        Select existing
      </button>
      <button class="dp-primary-btn wishlist-btn ms-3" type="submit">
        Create
      </button>
    </div>
  </form>
</div>